import React from "react";

import { PageContainer } from "@/marketing/Home.style.jsx";
import type { PageDefinition } from "@/marketing/home-constants.mjs";
import { PAGE_DEFINITION } from "@/marketing/home-constants.mjs";
import HomeGamePage from "@/marketing/HomeGamePage.jsx";
import HomeLanding from "@/marketing/HomeLanding.jsx";
import MarketingFooter from "@/marketing/MarketingFooter.jsx";
import { findGameSymbol, useGameSymbol } from "@/util/game-route.mjs";
import testId from "@/util/test-id.mjs";

export default function Home() {
  const gameSymbol = useGameSymbol();

  const SubPage = !gameSymbol ? HomeLanding : HomeGamePage;

  return (
    <PageContainer {...testId("home-page")}>
      <SubPage />
      <MarketingFooter lift />
    </PageContainer>
  );
}

Home.fullBleed = true;
Home.showPageHeader = false;

export function meta() {
  const gameSymbol = findGameSymbol();
  return (PAGE_DEFINITION[gameSymbol!] as PageDefinition)?.meta;
}
